export default __webpack_public_path__ + "static/media/elmer701.88a0d8a5.jpg";